import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import ngInfiniteScroll from 'ng-infinite-scroll';
import { DesignModule } from '@/Foundation/Design/platform';
import { SharedModule } from '@/Foundation/Shared/platform/app/module';

import { PfmPagerComponent } from './pfm-pager/pfm-pager.component';
import { ProductFilterGroupComponent } from './product-filter-group/product-filter-group.component';
import { ProductItemLabelsComponent } from './product-item-labels/product-item-labels.component';
import { ProductItemSkuComponent } from './product-item-sku/product-item-sku.component';
import { ProductItemComponent } from './product-item/product-item.component';
import { ProductItemFeatures } from './product-item-features/product-item-features.component';
import { ProductOrdersComponent } from './product-orders/product-orders.component';

import { PfmController } from './product-filter-module-spot/product-filter-module-spot.controller';

import { ProductReadMoreDirective } from './directives/product-read-more.directive';
import { ProductToolbarStickyDirective } from './directives/product-toolbar-sticky.directive';

import { PfmLoadQueueService, PfmUrlHelperService } from './services';
import { ProductFilterModuleApiService } from './services/product-filter-module-api.service';

const moduleId = 'gn.audio.public.product-finder';
const legacyModuleId = `${moduleId}.legacy`;

module(legacyModuleId, [])
  .controller('PfmController', PfmController);

@NgModule({
  declarations: [
    PfmPagerComponent,
    ProductFilterGroupComponent,
    ProductItemComponent,
    ProductItemLabelsComponent,
    ProductItemSkuComponent,
    ProductItemFeatures,
    ProductOrdersComponent,

    ProductReadMoreDirective,
    ProductToolbarStickyDirective,
  ],
  id: moduleId,
  imports: [
    ngInfiniteScroll,
    legacyModuleId,
    DesignModule,
    SharedModule,
  ],
  providers: [
    PfmLoadQueueService,
    PfmUrlHelperService,
    ProductFilterModuleApiService,
  ]
})
export class ProductFinderModule {
}

module('infinite-scroll')
  .value('THROTTLE_MILLISECONDS', 250);
